import { SpedDocumentStatus } from '../sped-documents/sped-documents.types';

export interface SpedFileConsult {
  message: string;
  status: SpedDocumentStatus;
}

export enum SpedFileDownloadType {
  TAX = 'TAX',
  CONTRIBUTIONS = 'CONTRIBUTIONS',
}

export const SpedFileDownloadTypeLabels: Record<SpedFileDownloadType, string> =
  {
    TAX: 'EFD ICMS/IPI(Fiscal)',
    CONTRIBUTIONS: 'EFD PIS/COFINS(Contribuições)',
  };

export interface SpedFileDownloadRequest {
  spedDocumentId: number;
  type: SpedFileDownloadType;
}
